import React from 'react';
import '../styles.scss';
import { Assets } from '../../finder/components/Assets';
import { Search } from '../../search/components/Search';
import { ClearFavoritesButton } from './ClearFavoritesButton';
import { AppLayout } from '../../app/components/AppLayout';
import { RoutedFullscreenPreview } from '../../fullscreenPreview/components/RoutedFullscreenPreview';
import { routes } from '../../router/model';
import { PageTabs } from '../../app/components/PageTabs';
import { DetailsToggleButton } from '../../finder/components/DetailsToggleButton';

export const FavoritesPage = () => {
  return (
    <AppLayout leftSider={false} rightSider={true}>
      <RoutedFullscreenPreview parentPath={routes.favorite} />
      <div className="al-favorite-page">
        <div className="al-favorite-page-top">
          <div className="al-favorite-page-top__left">
            <ClearFavoritesButton />
            <Search />
          </div>
          <PageTabs />
          <DetailsToggleButton />
        </div>

        <Assets />
      </div>
    </AppLayout>
  );
};
